module.exports = __webpack_public_path__ + "static/img/user-logo.ab78cf01.png";